import { useLayoutEffect, useState } from "react";

export function useClientLoaded() {
  const [clientLoaded, setClientLoaded] = useState(false);

  useLayoutEffect(() => {
    setClientLoaded(true);
  }, []);

  return { clientLoaded };
}
